<template>
  <div class="clerk-details">
    <div class="steps">
      <span
        class="step"
        :class="active === index ? 'active' : ''"
        v-for="(item, index) in step"
        :key="index"
        @click="swicthNav(index)"
      >
        {{ item }}
      </span>
    </div>
    <div :is="dynamicComponent"></div>
  </div>
</template>
<script>
import ClerkInfo from './ClerkInfo/clerkInfo'
import CustomInfo from './CustomInfo/customInfo'
import OrderInfo from './OrderInfo/orderInfo'
const COMPONENTS = [ClerkInfo, OrderInfo, CustomInfo]
export default {
  name: 'clerkDetails',
  data() {
    return {
      step: ['店员信息', '关联订单', '关联客户'],
      active: 0,
      dynamicComponent: COMPONENTS[0]
    }
  },
  methods: {
    swicthNav(index) {
      this.active = index
      this.dynamicComponent = COMPONENTS[index]
    }
  }
}
</script>
<style lang="scss">
.clerk-details {
  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 3.8rem;
    background-color: #fff;
    margin-bottom: 1.3rem;
    .step {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 7.5rem;
      height: 2rem;
      border-radius: 1rem;
      border: 1px solid colors('bg-main');
      margin-right: 3.8rem;
      cursor: pointer;

      &.active {
        background-color: #d5b68a;
        color: #fff;
        border: 0;
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: -3.8rem;
        width: 3.8rem;
        height: 1px;
        margin: auto;
        background-color: #34313a;
      }

      &:last-child {
        &:after {
          display: none;
        }
      }
    }
  }
}
</style>
